import type { Redemption } from "../api";

export function isCouponAvailable(
  redemption: Pick<Redemption, "status" | "qrPayload" | "qrExpiresAt">,
  now = Date.now(),
): boolean {
  return redemption.status.toLocaleLowerCase() === "issued"
    && Boolean(redemption.qrPayload)
    && Boolean(redemption.qrExpiresAt)
    && new Date(redemption.qrExpiresAt ?? 0).getTime() > now;
}

export function redemptionStatusLabel(status: string): string {
  switch (status.toLocaleLowerCase()) {
    case "issued":
      return "Available";
    case "fulfilled":
    case "redeemed":
      return "Redeemed";
    case "cancelled":
      return "Cancelled";
    case "expired":
      return "Expired";
    default:
      return status.replaceAll("_", " ");
  }
}
